// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

/**
 * İlk ekranın ÖNÜNE geçmeyen yükleme.
 *
 * İlk açılışta 26 istek gidiyordu ve bunların bir kısmı ekranı çizmek için gerekli değildi:
 * depolama kullanımı (tek başına 395 ms), lisans özeti, sektör listesi, içe aktarma biçimleri.
 * Hepsi ilk ekranın verisiyle aynı anda ağa yükleniyor ve asıl içeriği geciktiriyordu
 * (2026-08-30 ölçümü: ilk boyama 184 ms, veri 1594 ms boyunca doluyordu).
 *
 * Bu yardımcı işi iki koşul sağlanana kadar bekletir: sayfa yüklenmiş olacak VE üstüne kısa bir
 * sessizlik geçecek. `requestIdleCallback` tek başına yetmez — o yalnız ana iş parçacığının boş
 * olduğuna bakar, ağın boş olduğuna bakmaz; sayfa verisi hâlâ inerken "boşta" sayılır.
 *
 * Ne zaman KULLANILMAZ: kullanıcının o an baktığı ekranın verisi. Onu ertelemek, boş ekranı
 * daha uzun süre boş tutmak demektir.
 */
export function bostaYukle(is: () => void, gecikmeMs = 800): void {
  const basla = (): void => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(is, { timeout: 5000 });
    } else {
      setTimeout(is, 300);
    }
  };
  if (document.readyState === 'complete') setTimeout(basla, gecikmeMs);
  else window.addEventListener('load', () => setTimeout(basla, gecikmeMs), { once: true });
}
